import { IContainersByDestinationRegion } from "../../../api/ContainersByDestinationRegion/ContainersByDestinationRegion.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IContainersByDestinationRegion[];
}

function ContainersByDestinationRegion({ data }: Props) {
  let regions: any = [];

  function getData() {
    if (data) {
      const regionData = data
        .sort((a, b) => parseInt(b.containerCount) - parseInt(a.containerCount))
        .reduce((res: Record<string, number>, item: IContainersByDestinationRegion) => {
          const { destinationRegion, containerCount } = item;

          res[destinationRegion] = parseInt(containerCount);
          regions.push(item.destinationRegion);

          return res;
        }, {});

      return [regionData];
    }
  }

  return (
    <div className="containers-by-destination-region">
      <WidgetNivoBase.Bar
        title={
          <Tooltips
            label={
              <>
                <span><b>Destination Region:</b> PlaceOfReceipt or Port of Discharge</span>
                <span>Only includes <b>departed</b> containers</span>
              </>
            }
            children="Containers By Destination Region"
          />
        }
        data={getData()}
        keys={[...regions]}
        marginBottom={50}
        colors={{ scheme: "set2" }}
        groupMode="grouped"
        innerPadding={15}
        axisLeftName="# Containers"
        axisBottomName=""
        legendLabel={(el: any) => el.id.slice(0, 7)}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            itemWidth: 35,
            itemHeight: 12,
            itemDirection: "top-to-bottom",
            itemsSpacing: 8,
            symbolShape: "circle",
            symbolSize: 12,
            toggleSerie: true,
            translateX: 0,
            translateY: 30,
          },
        ]}
        formatValue={(v) => NumberUtils.toShortened(v, 2)}
        tooltip={({ id, value, color }) => (
          <div className="tooltip-panel" style={{ color }}>
            <div>{id ? `${id}: ` : ``}<strong>{NumberUtils.numberWithCommas(value)}</strong></div>
          </div>
        )}
      />
    </div>
  );
}

export default ContainersByDestinationRegion;
